var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { space, color, display, fontSize, boxShadow, textAlign, alignItems, flexDirection, justifyContent, themeGet, } from 'styled-system';
import RichTextBlock from '../../common/components/RichText';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { Grid, GridItem } from '../../common/components/Grid';
import { Heading } from '../../common/components/Text';
import { Link } from '../../common/components/Link';
import { ResponsiveLazyImage, ImagePropTypes, } from '../../common/components/LazyImage';
var defaultEventData = {
    event: 'homepageUspTeaserTracking',
    eventData: { placement: 'homepageUspTeaser' },
};
var UspTeaserGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), color, textAlign, boxShadow);
UspTeaserGrid.defaultProps = {
    bg: 'gray.14',
    mb: [3, 4, null, 5],
    textAlign: 'center',
    boxShadow: ['0 2px 6px 0 rgba(192, 192, 192, 0.5)', 'none'],
};
var UspTeaserGridItem = styled(GridItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
UspTeaserGridItem.defaultProps = {
    w: [1, null, 10 / 12],
    m: '0 auto',
};
var TitleGridItem = styled(GridItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
TitleGridItem.defaultProps = {
    w: [1, null, 10 / 12],
    m: '0 auto',
};
var Title = styled(Heading)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
Title.defaultProps = __assign({}, Heading.defaultProps, { mt: 5, mb: 0, as: 'h2', fontSize: [5, '26px'] });
var Subtitle = styled(RichTextBlock)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n\n  p {\n    ", ";\n  }\n"], ["\n  ", ";\n\n  p {\n    ", ";\n  }\n"])), space, fontSize);
Subtitle.defaultProps = {
    mt: [3, 4],
    fontSize: [4, 5],
};
var UspBlock = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), space, display, flexDirection, justifyContent);
UspBlock.defaultProps = {
    m: '0 auto',
    display: ['block', 'flex'],
    flexDirection: [null, 'row'],
    justifyContent: 'center',
};
var UspGridItem = styled(GridItem)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  &:last-of-type {\n    margin-bottom: ", "px;\n  }\n"], ["\n  ", ";\n  ", ";\n\n  &:last-of-type {\n    margin-bottom: ", "px;\n  }\n"])), space, textAlign, themeGet('space.5'));
UspGridItem.defaultProps = {
    mt: [4, 6],
    mb: [4, 5],
    textAlign: 'center',
    w: [1, 4 / 12, null, 3 / 12],
};
var ImageContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 65px;\n  height: 65px;\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  width: 65px;\n  height: 65px;\n\n  ", ";\n  ", ";\n  ", ";\n"])), space, display, alignItems);
ImageContainer.defaultProps = {
    m: '0 auto',
    display: 'flex',
    alignItems: 'center',
};
var Image = styled.img(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var UspBlockText = styled(RichTextBlock)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n\n  p {\n    ", ";\n  }\n"], ["\n  ", ";\n\n  p {\n    ", ";\n  }\n"])), space, fontSize);
UspBlockText.defaultProps = {
    mt: 3,
    fontSize: [4, 5],
};
var LinkContainer = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), space);
LinkContainer.defaultProps = {
    mt: [2, null, null, 3],
    mb: 5,
};
var LinkWithArrow = styled(Link)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  &:after {\n    content: '\x000a0\u203A';\n  }\n"], ["\n  &:after {\n    content: '\\00a0\u203A';\n  }\n"])));
LinkWithArrow.defaultProps = __assign({}, Link.defaultProps, { fontSize: [4, 5] });
var CommonUspTeaser = function (_a) {
    var title = _a.title, subtitleHtml = _a.subtitleHtml, items = _a.items, ctaLinkLabel = _a.ctaLinkLabel, ctaLinkHref = _a.ctaLinkHref, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    return (React.createElement(UspTeaserGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
        React.createElement(UspTeaserGridItem, null,
            React.createElement(TitleGridItem, null,
                React.createElement(Title, { "data-testid": "usp-teaser-title" }, title),
                !!subtitleHtml && (React.createElement(Subtitle, { "data-testid": "usp-teaser-subtitle", dangerouslySetInnerHTML: { __html: subtitleHtml } }))),
            React.createElement(UspBlock, null, items.map(function (_a, index) {
                var textHtml = _a.textHtml, imageProps = _a.image;
                return (React.createElement(UspGridItem, { "data-testid": "usp-block-" + index, key: index },
                    React.createElement(ResponsiveLazyImage, __assign({}, imageProps), function (_a) {
                        var thumbnail = _a.thumbnail, image = _a.image, loaded = _a.loaded;
                        return (React.createElement(ImageContainer, null,
                            React.createElement(Image, { "data-testid": "usp-block-image", src: loaded ? image : thumbnail, alt: imageProps.alt })));
                    }),
                    React.createElement(UspBlockText, { "data-testid": "usp-block-text", dangerouslySetInnerHTML: { __html: textHtml } })));
            })),
            !!ctaLinkLabel &&
                !!ctaLinkHref && (React.createElement(LinkContainer, { "data-testid": "link-container" },
                React.createElement(LinkWithArrow, __assign({}, getTrackerProps({
                    'data-testid': 'show-more-link',
                    href: ctaLinkHref,
                }, defaultEventData)), ctaLinkLabel))))));
};
CommonUspTeaser.propTypes = {
    title: PropTypes.string.isRequired,
    subtitleHtml: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
        image: PropTypes.shape(__assign({}, ImagePropTypes, { alt: PropTypes.string, thumbnail: PropTypes.string })),
        textHtml: PropTypes.string.isRequired,
    })).isRequired,
    ctaLinkLabel: PropTypes.string,
    ctaLinkHref: PropTypes.string,
    /** Should the max width be capped by current Reboot max width (default: true) */
    __legacy_shop_reboot_max_width: PropTypes.bool,
};
CommonUspTeaser.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default CommonUspTeaser;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
